import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import { isMacOs } from 'react-device-detect';


const EventsShareModal = ({ newsOpenModal, newsModalData, closeModal }: any) => {

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-09"
            open={newsOpenModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}>
            <Fade in={newsOpenModal}>
                <div className={isMacOs ? 'modal-09-content isMacOs' : 'modal-09-content'}>
                    <div className="c-wrapper">
                        <div className="modal-item" style={{}}>
                        <button 
                                style={{ position: "absolute" }} 
                                onClick={() => closeModal()} 
                                className="close-icon"
                                aria-label="Modalı kapat"
                                type="button"
                            >
                                <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M17.4882 18.8672L32.8551 34.2341L34.9764 32.1128L19.6096 16.7459L34.2341 2.12138L32.1128 5.7195e-05L17.4882 14.6246L2.86366 0L0.742336 2.12132L15.3669 16.7459L0 32.1128L2.12132 34.2341L17.4882 18.8672Z"
                                        fill="black"
                                    />
                                </svg>
                            </button>

                            <div className="c-item-01 event-iframe" style={{ width: "100%", height: "100%", marginRight: "0" }}>
                                <iframe
                                    src="https://khicindekocvar.blob.core.windows.net/cdn/prod/KG_KH_icindeKocVar_Aydinlatma_Metni.pdf"
                                    title="KVKK"
                                    style={{ 
                                        border: 'none',
                                        width: '100%',
                                        height: '100%',
                                        minHeight: '400px'
                                    }}
                                />
                            </div>


                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
};

export default EventsShareModal;
